<template>
  <div class="feedback-thumbs">
    <Button
      :class="['feedback-btn', { 'voted-up': vote === true }]"
      icon="pi pi-thumbs-up"
      text
      rounded
      size="small"
      :loading="loading"
      aria-label="Thumbs up"
      @click="handleVote(true)"
    />
    <Button
      :class="['feedback-btn', { 'voted-down': vote === false }]"
      icon="pi pi-thumbs-down"
      text
      rounded
      size="small"
      :loading="loading"
      aria-label="Thumbs down"
      @click="handleVote(false)"
    />
  </div>
</template>

<script>
import Button from 'primevue/button'
import { submitFeedback, getFeedback } from '@/services/feedbackService'
import { FEEDBACK_SUBMIT_ERROR_MSG } from '@/assets/constants/constants'

export default {
  name: 'FeedbackThumbs',

  components: { Button },

  props: {
    featureType: {
      type: String,
      required: true,
    },
    targetId: {
      type: Number,
      required: true,
    },
  },
  emits: ['error'],
  data() {
    return {
      vote: null,
      loading: false,
    }
  },

  async mounted() {
    try {
      const existing = await getFeedback(this.featureType, this.targetId)
      if (existing !== null && existing !== undefined) {
        this.vote = existing.value
      }
    } catch {
      // Non-fatal — widget shows neutral state if pre-fill fails
    }
  },

  methods: {
    async handleVote(value) {
      if (this.loading) return

      const previous = this.vote
      this.vote = value
      this.loading = true

      try {
        await submitFeedback(this.featureType, this.targetId, value)
      } catch {
        this.vote = previous
        this.$emit('error', FEEDBACK_SUBMIT_ERROR_MSG)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.feedback-thumbs {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.feedback-btn {
  color: #999 !important;
}

.feedback-btn.voted-up {
  color: #667eea !important;
}

.feedback-btn.voted-down {
  color: #e53935 !important;
}
</style>
